import axios from 'axios';
import {Power3, TweenMax} from "gsap/all";

export default class SearchSuggest {
  
  constructor() {
    if (this.setVars()) {
      this.setEvents();
    }
  }
  
  setVars() {
    
    this.settings = {
      'main': 'data-search-suggest',
      'form': 'data-search-suggest-form',
      'input': 'data-search-suggest-input',
      'wrapper': 'data-search-suggest-boxes-wrapper',
      'loader': ' data-search-suggest-loader',
      'box': 'data-search-suggest-box',
    };
    
    this.search_suggest = document.querySelector(`[${this.settings.main}]`);
    
    this.setLoading(false);
    
    if (!this.search_suggest) return;
    
    return true;
  }
  
  setEvents() {
    const form = this.search_suggest.querySelector(`[${this.settings.form}]`);
    const input = form.querySelector(`[${this.settings.input}]`);
    
    form.addEventListener('click', () => {
      TweenMax.to(window, 1, { scrollTo: {y: 0}, ease: Power3.easeInOut })
      form.addClass('active_suggest');
    });
  
    input.addEventListener('keyup', (e) => {
      if (e.target.value.length >= 3) {
        this.getPosts(e.target.value)
      }
    });
  
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.searchBox')) {
        form.removeClass('active_suggest');
      }
    });
  }
  
  getPosts(value) {
    this.setLoading(true);
    const suggest = this.search_suggest.querySelector(`[${this.settings.wrapper}]`);
    suggest.innerHTML = '';
    
    const url = this.search_suggest.getAttribute(this.settings.main);
    axios.get(url + '?s=' + value )
      .then( (response) => {
        suggest.innerHTML = response.data;
        this.setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  
  setLoading(isLoading) {
    if (!this.search_suggest) return;
    
    const loader = this.search_suggest.querySelector(`[${this.settings.loader}]`)
    
    if (isLoading) {
      loader.addClass('active_loader');
    } else {
      loader.removeClass('active_loader');
    }
  }
}
